import { ProjectTypes } from '../../utils/constants';
import FormEditProjectAirSubstation from '../FormEditProjectAirSubstation';
import FormEditProjectSolarEnergy from '../FormEditProjectSolarEnergy';

export default function GetEditProjectData({ dados, projectType, ...props }) {
  const getProjectStructure = () => {
    switch (projectType) {
      case ProjectTypes.SOLAR_ENERGY:
        return <FormEditProjectSolarEnergy dados={dados} {...props} />;
      case ProjectTypes.AIR_SUBSTATION:
        return <FormEditProjectAirSubstation dados={dados} {...props} />;
      default:
        return null;
    }
  };

  return getProjectStructure();
}
